export default {
    isSelected: true,
    boxes: [
        // Product Selector
        {
            bannerText: "product-selector",
            heading: "product-selector-heading",
            text: "",
            image: "Product_Selector_Group.jpg",
            apiName: "Selector",
            toolType: "Selector",
            isSelected: false
        },

        // Linear Motioneering
        {
            bannerText: "size-your-system",
            heading: "size-your-system-heading",
            text: "",
            image: "Sizing_and_Selection.jpg",
            apiName: "Motioneering",
            toolType: "Motioneering",
            isSelected: false
        },

        // Parser
        {
            bannerText: "build-enter-partnumber",
            heading: "build-enter-partnumber-heading",
            text: "",
            image: "Build_Part_Number.png",
            apiName: "Parser",
            toolType: "Parser",
            isSelected: false
        },

        // Contact Thomson
        {
            bannerText: "contact-thomson",
            heading: "contact-thomson-heading",
            text: "",
            image: "Contact_Thomson.png",
            apiName: "ContactThomson",
            toolType: "ContactThomson",
            redirectUrl: "path.tlo.contact-us",
            isSelected: false
        },
    ]
}